module.exports = __webpack_public_path__ + "static/media/partner_logo.799c779e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/coolRide/images/partner_logo.svg
// module id = 582
// module chunks = 0